import { Injectable } from "@angular/core";
import { CommonService } from "./common.service";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { JwtHelperService } from '@auth0/angular-jwt';
import { Utility } from "../services/utility.service";

@Injectable({
  providedIn: 'root'
})

export class AuthenticateService {
  public token: string;
  constructor(private commonService: CommonService, private router: Router) {
  }

  public isAuthenticated(activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const jwtHelper = new JwtHelperService();
    const bearerToken=this.commonService.bearerToken;
    const decodedToken = jwtHelper.decodeToken(bearerToken);
    const expirationDate = jwtHelper.getTokenExpirationDate(bearerToken);
    const isExpired = jwtHelper.isTokenExpired(bearerToken);
    let child = activatedRoute.firstChild;
    try {
      if (Utility.IsStringNotNullOrEmpty(activatedRoute.data["ComponentName"])) {
        let currentComponentName: string = activatedRoute.data["ComponentName"];
        return true;
        // return (this.commonService.currentUser.menuItemsForUser?.filter(x => x.ComponentName.toLowerCase() === currentComponentName.toLowerCase())?.length > 0 || currentComponentName.toLowerCase() === "layoutcomponent".toLowerCase()) && Number(decodedToken.name) === this.commonService.currentUser.Id && !isExpired ? true : false;
      }
      else if (state.url) {
        let currentUrl = state.url.split('?')[0];
        return true;
        // return this.commonService.currentUser.menuItemsForUser?.filter(x => x.routerLink?.includes(currentUrl))?.length > 0 && Number(decodedToken.name) === this.commonService.currentUser.Id && !isExpired ? true : false;
      }
      else return false
    }
    catch (e) {
      return false;
    }
  }
}
